export default __webpack_public_path__ + "static/media/InsideLungs_09.221bc4f7.png";